var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-905 -877)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#Add_svg__filter-2)",
    xlinkHref: "#Add_svg__path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#Add_svg__path-1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.039v6.923M10.961 7.5H4.038"
  }))))));
};
export { SvgAdd as ReactComponent };
export default "data:image/svg+xml,%3csvg width='17px' height='17px' viewBox='0 0 17 17' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cg id='Platform' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='My-Account' transform='translate(-905.000000, -877.000000)'%3e %3cg id='Rectangle-Copy-19'%3e %3cuse fill='black' fill-opacity='1' filter='url(%23filter-2)' xlink:href='%23path-1'%3e%3c/use%3e %3cuse fill='%23FFFFFF' fill-rule='evenodd' xlink:href='%23path-1'%3e%3c/use%3e %3c/g%3e %3cg id='Group-43' transform='translate(906.000000, 877.000000)' stroke='currentColor' stroke-width='1.5'%3e %3cg id='Group-28' transform='translate(0.000000, 1.000000)'%3e %3ccircle id='Oval' cx='7.5' cy='7.5' r='7.5'%3e%3c/circle%3e %3cg id='Group-27' transform='translate(4.038462, 3.461538)' stroke-linecap='square'%3e %3cline x1='3.46153846' y1='0.576923077' x2='3.46153846' y2='7.5' id='Line-2'%3e%3c/line%3e %3cline x1='6.92307692' y1='4.03846154' x2='0' y2='4.03846154' id='Line-2'%3e%3c/line%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";